var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenomicsBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 846,
    viewBox: "0 0 140 846",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.591 39.1085H134.055V810.192H139.591V39.1085Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.536 39.1085H3V810.192H8.536V39.1085Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.519 3.37805H14.0723V21.2438H128.519V3.37805Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.056 21.2444H128.52V39.1101H134.056V21.2444Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0712 21.2444H8.53516V39.1101H14.0712V21.2444Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2753 826.196H14.0723V844.062H79.2753V826.196Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 828.4H16V845.151H128V828.4Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0712 808.331H8.53516V826.197H14.0712V808.331Z",
    fill: "#32adff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.056 810.193H128.52V828.058H134.056V810.193Z",
    fill: "#32adff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.591 37.7445H131.055V808.828H136.591V37.7445Z",
    fill: "#32adff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.536 35.8829H0V806.966H5.536V35.8829Z",
    fill: "#32adff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.519 0.151611H11.0723V18.0173H125.519V0.151611Z",
    fill: "#32adff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.056 18.0179H125.52V35.8835H131.056V18.0179Z",
    fill: "#32adff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0712 18.0179H5.53516V35.8835H11.0712V18.0179Z",
    fill: "#32adff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125 824.678H11V841.429H125V824.678Z",
    fill: "#32adff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0712 805.106H5.53516V822.971H11.0712V805.106Z",
    fill: "#32adff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.056 806.967H125.52V824.833H131.056V806.967Z",
    fill: "#32adff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15.0416,
    width: 109,
    height: 809.636,
    fill: "#32adff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35.5153,
    width: 6,
    height: 770.55,
    fill: "#32adff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 18.7642,
    width: 6,
    height: 805.914,
    fill: "#32adff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 35.5153,
    width: 6,
    height: 772.412,
    fill: "#32adff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29.9314,
    width: 6,
    height: 29.7797,
    fill: "#FEE681"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29.9314,
    width: 14,
    height: 29.7797,
    fill: "#FAC542"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 29.9314,
    width: 35,
    height: 29.7797,
    fill: "#E1A22D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 29.9314,
    width: 28,
    height: 29.7797,
    fill: "#FEC44B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 29.9314,
    width: 3,
    height: 29.7797,
    fill: "#FFC046"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29.9314,
    width: 3,
    height: 29.7797,
    fill: "#FFBE4A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 59.7108,
    width: 4,
    height: 716.575,
    fill: "#FFBE4A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 59.7108,
    width: 4,
    height: 716.575,
    fill: "#FFBE4A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 781.87,
    width: 6,
    height: 27.9185,
    fill: "#FEE681"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 781.87,
    width: 14,
    height: 27.9185,
    fill: "#FAC542"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 781.87,
    width: 35,
    height: 27.9185,
    fill: "#E1A22D"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 781.87,
    width: 28,
    height: 27.9185,
    fill: "#FEC44B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 781.87,
    width: 3,
    height: 27.9185,
    fill: "#FFC046"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 781.87,
    width: 3,
    height: 27.9185,
    fill: "#FFBE4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 135.152V111.152H57.5V105.152H81.5V111.152H75.5V135.152H63.5ZM60.5 202.152V196.152H54.5V178.152H60.5V172.152H78.5V178.152H84.5V196.152H78.5V202.152H60.5ZM66.5 195.912H72.5V178.392H66.5V195.912ZM54.5 269.152V239.152H66.5V245.152H72.5V239.152H84.5V245.152H78.5V251.152H72.5V257.152H78.5V263.152H84.5V269.152H72.5V263.152H66.5V269.152H54.5ZM57.5 336.152V306.152H81.5V312.152H69.5V318.152H81.5V324.152H69.5V330.152H81.5V336.152H57.5ZM51.5 403.152V373.152H63.5V379.152H69.5V385.152H75.5V373.152H87.5V403.152H75.5V397.152H69.5V391.152H63.5V403.152H51.5ZM60.5 470.152V464.152H54.5V446.152H60.5V440.152H78.5V446.152H84.5V464.152H78.5V470.152H60.5ZM66.5 463.912H72.5V446.392H66.5V463.912ZM51.5 537.152V507.152H63.5V513.152H75.5V507.152H87.5V537.152H75.5V525.152H63.5V537.152H51.5ZM63.5 604.152V574.152H75.5V604.152H63.5ZM60.5 671.152V665.152H54.5V647.152H60.5V641.152H78.5V647.152H84.5V653.152H72.5V647.152H66.5V665.152H72.5V659.152H84.5V665.152H78.5V671.152H60.5ZM54.5 738.152V732.152H72.5V726.152H60.5V720.152H54.5V714.152H60.5V708.152H84.5V714.152H66.5V720.152H78.5V726.152H84.5V732.152H78.5V738.152H54.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenomicsBanner);
export default __webpack_public_path__ + "static/media/tokenomics-banner.333b2602d7d43743cd0731bcde4922d5.svg";
export { ForwardRef as ReactComponent };